import RequestModule from '@/assets/libs/requestModule'

const getUserStatusByEmail = async function (email) {
  try {
    const data = {
      email: email
    }

    const response = await RequestModule.postRequest('api-socio/get-user-status-by-email', data)
    return response
  } catch (error) {
    const message = error?.response?.data?.message || 'Erro ao consultar status do sócio.'
    console.error('ApiSocioController Error:', message)
    return {
      error: true,
      message
    }
  }
}

const registerUser = async function (email, name, password) {
  try {
    const data = {
      email,
      name,
      password
    }

    const response = await RequestModule.postRequest('api-socio/register', data)
    return response
  } catch (error) {
    const message = error?.response?.data?.message || 'Erro ao registrar sócio.'
    console.error('ApiSocioController Error:', message)
    return {
      error: true,
      message
    }
  }
}

const getUserStatusByCpf = async function (cpfs, isComplete = false) {
  try {
    const data = {
      cpfs,
      isComplete
    }

    const response = await RequestModule.postRequest('api-socio/get-user-status-by-cpf', data)
    return response
  } catch (error) {
    const message = error?.response?.data?.message || 'Erro ao consultar status do sócio por CPF.'
    console.error('ApiSocioController Error:', message)
    return {
      error: true,
      message
    }
  }
}

export {
  getUserStatusByCpf, getUserStatusByEmail,
  registerUser
}
